export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";